import { WaybillIdView } from '../../../../models/shipment-id-view.model';

export class ShipmentWaybillTrackingMapLoad {
  public static readonly type = '[ShipmentWaybillTrackingMap] Load';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillTrackingMapInitialState {
  public static readonly type = '[ShipmentWaybillTrackingMap] Set Initial State';
}
